import { service } from "../../../services";

const state = {
  query: "",
  result: [],
  error: null
};

const mutations = {
  setQuery(state, query) {
    state.query = query;
  },

  searchSuccess(state, result) {
    state.offers = result;
  },

  searchFail(state, error) {
    state.error = error;
  }
};

const actions = {
  requestSuccess({ commit }, result) {
    commit("searchSuccess", result);
  },

  requestFailure({ commit }, error) {
    commit("searchFail", error);
  },

  async searchOffers({ commit, dispatch }, query) {
    try {
      const res = await service.get("/offers?limit=100&=" + query);
      console.log(res.items);
      return;
      dispatch("offers/searchResults", res.items, { root: true });
    } catch (e) {
      dispatch("requestFailure", e);
    }
  }
};

export const search = {
  namespaced: true,
  state,
  actions,
  mutations
};
